import api from "@/services/api";

class GrantPartnerPremiumVoucher {
  execute = async (beneficiaryPartnerId: string) => {
    const response = await api().post("/associate-premium/vouchers/grant-partner", {
      beneficiaryPartnerId,
    });
    return response.data;
  };
}

export { GrantPartnerPremiumVoucher };
